'use strict';

export { processBackgroundImage } from "./backgroundImage.js";
export { DynamicColorIOS, PlatformColor, processColor, processColorNumber, processColorsInProps } from "./colors.js";
export { processFilter } from "./filter.js";
export { processFontWeight } from "./font.js";
export { processInset, processInsetBlock, processInsetInline } from "./insets.js";
export { processAspectRatio, processGap } from "./others.js";
export { processBoxShadow } from "./shadows.js";
export { processTransform } from "./transform.js";
export { processTransformOrigin } from "./transformOrigin.js";
//# sourceMappingURL=index.js.map